export default "__VITE_ASSET__Bzl33y6U__"